import { useQuery } from "@tanstack/react-query";
import {
	IncentiveDisbursementFilters,
	IncentiveDisbursementResponse,
	reportsService,
} from "../../services/reports.service";

const useIncentiveDisbursementReport = (
	filters: IncentiveDisbursementFilters,
) => {
	const enabled = Boolean(filters.accountId && filters.programId);

	return useQuery<IncentiveDisbursementResponse>({
		queryKey: [
			"reports-incentive-disbursement",
			filters.accountId,
			filters.programId,
			filters.orgUnitId ?? "",
			filters.researcherId ?? "",
			filters.startDate ?? "",
			filters.endDate ?? "",
			filters.pageNumber ?? 0,
			filters.pageSize ?? 10,
		],
		queryFn: () => reportsService.getIncentiveDisbursement(filters),
		enabled,
		staleTime: 1000 * 60 * 5,
	});
};

export default useIncentiveDisbursementReport;
